const L = {
  en: {
    LOCAL_LOGIC: "Local Logic",
    POWERED_BY: "Powered by"
  },
  fr: {
    LOCAL_LOGIC: "Local Logic",
    POWERED_BY: "Propulsé par"
  }
};
export {
  L as translations
};
